import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { usePreviewBaseStyles } from '../../styles';
import { SequentialNavigator } from './sequential-navigator';

export const AssetItemPreviewBase = ({
  itemData,
  totalCount,
  currentIndex,
  onNext,
  onPrevious,
  shouldHideContent,
  i18n,
  onRenderPreviewContent,
}) => {
  const classes = usePreviewBaseStyles();

  return (
    <div className={classnames('item-preview-container', classes.previewContainer, shouldHideContent && classes.fadeOut)}>
      <div className={classnames('item-content-container', classes.content)}>
        {onRenderPreviewContent({ itemData })}
      </div>
      <SequentialNavigator
        totalCount={totalCount}
        currentIndex={currentIndex}
        onNext={onNext}
        onPrevious={onPrevious}
        i18n={i18n}
      />
    </div>
  );
};

AssetItemPreviewBase.propTypes = {
  itemData: PropTypes.shape({}),
  totalCount: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  shouldHideContent: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onRenderPreviewContent: PropTypes.func.isRequired,
};

AssetItemPreviewBase.defaultProps = {
  itemData: null,
  shouldHideContent: false,
};
